// src/app/i18n/translations.hi.ts
export const TRANSLATIONS_HI = {
  heroTitle: "सहकारिता विभाग में आपका स्वागत है",
  heroDesc: "आपकी समिति के प्रबंधन, सदस्य जानकारी और सेवाओं तक सुरक्षित और आसान डिजिटल पहुँच।",

 username: "(सहकारी समिति: यूज़र आईडी / कर्मचारी: PMIS ) ",
  password: "पासवर्ड",
  captcha: "सुरक्षा कोड",
  rememberMe: "मुझे साइन इन रखें",
  forgotPassword: "पासवर्ड भूल गए?",
  login: "पोर्टल एक्सेस करें",
  loginOtp: "ओटीपी के साथ लॉग इन करें",
  or: "या जारी रखें",
  welcomeBack: "स्वागत है",
  secureLogin: "सुरक्षित पोर्टल लॉगिन",
  footer: "© 2024 हिमाचल प्रदेश सरकार"
};
export const ReTRANSLATIONS_HI = {
  signUpTitle: "नया खाता बनाएँ",
  signUpDesc: "समिति सेवाओं तक पहुँच, प्रोफ़ाइल प्रबंधन और डिजिटल रूप से जुड़े रहने के लिए पंजीकरण करें।",

  fullName: "पूरा नाम",
  mobileNumber: "मोबाइल नंबर",
  email: "ईमेल पता",
  pmisNumber: "PMIS नंबर",
  confirmPassword: "पासवर्ड की पुष्टि करें",

  signUp: "पंजीकरण करें",
  alreadyHaveAccount: "पहले से खाता है?",
  loginHere: "यहाँ लॉग इन करें",

  acceptTerms: "मैं नियम और शर्तों से सहमत हूँ",
  verifyOtp: "ओटीपी सत्यापित करें",
  resendOtp: "ओटीपी पुनः भेजें"
};
export const forTRANSLATIONS_HI = {

  forgetPasswordTitle: "अपना पासवर्ड रीसेट करें",
  forgetPasswordDesc: "पासवर्ड रीसेट करने के लिए अपना पंजीकृत ईमेल, मोबाइल नंबर, या PMIS नंबर दर्ज करें।",
  submit: "सबमिट करें",
  backToLogin: "लॉगिन पर वापस जाएँ",
  otpSent: "OTP आपके पंजीकृत संपर्क पर भेजा गया है",
  resetPassword: "पासवर्ड रीसेट करें",
  newPassword: "नया पासवर्ड",
  confirmNewPassword: "नए पासवर्ड की पुष्टि करें",
  passwordResetSuccess: "आपका पासवर्ड सफलतापूर्वक रीसेट हो गया है। अब आप लॉगिन कर सकते हैं।",
  resendOtp: "OTP पुनः भेजें"
};
